import { useGetAllTrainerList } from "../../../assets/nodeApi/getApi/getAdminApi";


export const useTrainerOptions = (filters) => {
    
    const { data: trainerList, isLoading: isTrainerLoading } = useGetAllTrainerList(filters);
    const trainerOption = trainerList?.data?.map((item, index) => ({
        id: item?.id,
        sr_no: index + 1,
        label:`${item?.firstname || ''} ${item?.lastname || ''}`.trim(),
        value: `${item?.firstname || ''} ${item?.lastname || ''}`.trim(),
        ...item,
    }));

    return {
        AllTrainer: {
            options: trainerOption,
            isLoading: isTrainerLoading,
        },
    };
};
